// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"72de5c41","732":"844dc533","977":"7dfde9ba"}[chunkId] + ".chunk.js";
};